import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            观众评价
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            听听影迷们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 rounded-xl border border-background-200/70 p-5 flex flex-col"
            >
              <div className="flex items-center gap-3">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-10 h-10 rounded-full object-cover"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    const parent = target.parentElement;
                    if (parent) {
                      const fallback = parent.querySelector('.avatar-fallback');
                      if (fallback) (fallback as HTMLElement).style.display = 'flex';
                    }
                  }}
                />
                <div className="avatar-fallback hidden w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-xs font-medium text-primary-600">{comment.name.charAt(0)}</span>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{comment.name}</h3>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{comment.time}</span>
                </div>
              </div>
              <p className="mt-3 text-xs text-foreground-600 leading-relaxed flex-1">{comment.content}</p>
              <div className="mt-3 flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}